import { all, put, call, takeLatest } from 'redux-saga/effects';
import ApiService from '@/services/Api';
import actions, { actionTypes } from './actions';
import leadActions from '@/redux/lead/actions';

function* fetchAgreements({ payload }) {
  try {
    const { data } = yield call(ApiService.fetchAgreements, payload);
    yield put(actions.fetchSuccess(data));
  } catch (error) {
    yield put(actions.fetchFailed(error));
  }
}

function* createAgreement({ payload }) {
  try {
    const { data } = yield call(ApiService.createAgreement, {
      lead: payload.leadId,
      agreement_type: payload.agreementType,
    });
    yield put(actions.createAgreementSuccess(data));
    yield put(leadActions.fetchLead(payload.leadId));
  } catch (error) {
    yield put(actions.createAgreementFailed(error));
  }
}

export default function* () {
  yield all([
    takeLatest(actionTypes.FETCH_AGREEMENTS, fetchAgreements),
    takeLatest(actionTypes.CREATE_AGREEMENT, createAgreement),
  ]);
}
